import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 * The padlock on gated features. Put on an `<svg>` so the host's own classes
 * size it; it paints in `currentColor`.
 */
@Component({
  selector: 'svg[appLockIcon]',
  template: `<svg:path
    d="M1.45 15.48c-.4 0-.74-.14-1.02-.41A1.35 1.35 0 0 1 0 14.09V6.87c0-.39.14-.71.42-.98.29-.28.63-.41 1.03-.41H2.4V3.94c0-.96.35-1.78 1.05-2.45A3.5 3.5 0 0 1 6 .48c1 0 1.85.34 2.55 1.01.7.67 1.05 1.49 1.05 2.45v1.54h.95c.4 0 .74.13 1.02.41.29.27.43.59.43.98v7.22c0 .38-.14.7-.43.98-.28.27-.62.41-1.02.41H1.45Zm0-1.15h9.1c.08 0 .14-.03.18-.07a.23.23 0 0 0 .07-.17V6.87a.23.23 0 0 0-.07-.17.25.25 0 0 0-.18-.07h-9.1a.25.25 0 0 0-.18.07.23.23 0 0 0-.07.17v7.22c0 .07.02.13.07.17.04.04.1.07.18.07ZM6 11.82c.39 0 .72-.13.99-.39.27-.26.41-.58.41-.95 0-.38-.14-.7-.41-.96A1.37 1.37 0 0 0 6 9.13c-.39 0-.72.13-.99.39-.27.26-.41.58-.41.96 0 .37.14.69.41.95.27.26.6.39.99.39ZM3.6 5.48h4.8V3.94c0-.65-.23-1.19-.7-1.64A2.4 2.4 0 0 0 6 1.63c-.67 0-1.23.22-1.7.67-.47.45-.7.99-.7 1.64v1.54Z"
    fill="currentColor"
  />`,
  host: { viewBox: '0 0 12 16', 'aria-hidden': 'true' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LockIconComponent {}
